import type { FaireProductEntity } from "../../entity_types/product";

export const p_tmumja993v: FaireProductEntity = {
  token: "p_tmumja993v",
  type: "product",
  name: "JUICE BALM",
  brandToken: "b_sbb9hxmx99",
  brandName: "Touchy Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/917357c97495354febb1b95b67d7c08f9429d65a8c6b49e8d0e0861e3fa573ec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fb767bea343586a5957956ee3462a2d76a2769bbf0ccdba3dba79ec50f6312b0.jpeg",
    "https://cdn.faire.com/fastly/31faa88a9513f9d92452e77bdfd85a35bec556b8f2708400f41a0d012c24479f.jpeg",
    "https://cdn.faire.com/fastly/2bd2c7815a157aacc350b32988632d6e5a3e06fc03809592bf30930d213e8e56.jpeg",
  ],
  priceDollars: 33,
  description:
    "Good For: Cold Coffee\nTaste Notes: Fruit Medley, Refreshing, Shiny\nServe It: Flash-chill, Japanese iced, cold-brew concentrate. Best with clinking cubes and a soundtrack that slaps.\nSizing: Available in 12oz retail bags or 2lb + 5lb bulk bags for brewing!\n\nWhether cold coffee is a just a warm weather fling or a year round thing, Juice Balm is your perpetual cooler of fruit-punch daydreams. One tilt of the glass and BAM. Everything’s suddenly pool-party neon.\n\nThe origin rotates, but the flavor blueprint is locked: juicy fruit, soft florals, clean finish. The only surprise is how consistently crushable it is.\n\n𝐕𝐢𝐛𝐞 𝐍𝐨𝐭𝐞𝐬\n• Berry Popsicle Drip\n• Honeysuckle Spritz\n• Lime Zest Confetti\n\nP.S. JUICE BALM is your ride-or-die for iced coffee joy. While the fruit-forward coffee inside changes seasonally, the juicy, floral vibe stays locked in. Each bag ships with a sticker naming the current single origin.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:08.040Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
